<template>
    <div>
        <div class="content-header">
            <PageTitleComponent title="Crear incidencia"/>
        </div>

        <section class="content">
            <div class="container-fluid">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Crear incidencia</h3>
                        <div class="card-tools">
                        </div>
                    </div>
                    <div class="card-body" v-if="!loading">
                        <div class="row">
                            <div class="col-12">
                                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                                    <div class="row">
                                        <div class="col-12">
                                            <FormInput label="Asunto" name="asunto" id="asunto" rules="required" v-model="incidencia.asunto" />
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label for="prioridad">Mensaje</label>
                                                <ValidationProvider name="mensaje" rules="required" v-slot="{ errors }">
                                                    <CkEditorComponent v-model="incidencia.mensaje" id="mensaje"/>
                                                    <span id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label for="prioridad">Prioridad</label>
                                                <ValidationProvider name="prioridad" rules="required" v-slot="{ errors }">
                                                    <multiselect v-model="incidencia.prioridad" :options="prioridades" track-by="name" label="name" id="prioridad"/>
                                                    <span id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label for="role">Departamento</label>
                                                <ValidationProvider name="role" rules="required" v-slot="{ errors }">
                                                    <multiselect v-model="incidencia.role" :options="roles" track-by="name" label="name" id="role"/>
                                                    <span id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="col-12 text-right">
                                            <Button type="submit" name="crear" id="crear" :disabled="loading">CREAR</Button>
                                        </div>
                                    </div>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-else>
                        <LoaderComponent/>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitleComponent from '@/components/backend/components/PageTitleComponent';
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';

    export default {
        data(){
            return {
                incidencia: {},
                prioridades: [],
                roles: [],
                loading: false,
                conf: {}
            }
        },
        methods: {
            getPrioridades() {
                const params = {
                    filters: {},
                };

                this.$store.dispatch(this.config.getVuexAlias('back.mensajeria.prioridades'), params).then(res => {
                    this.prioridades = res.data.data;
                });
            },
            getRoles() {
                const params = {
                    filters: {},
                };

                this.$store.dispatch(this.config.getVuexAlias('back.mensajeria.roles'), params).then(res => {
                    this.roles = res.data.data;
                });
            },
            async submit(){
                const isValid = await this.$refs.observer.validate();
                if (isValid){
                    this.loading = true;

                    this.incidencia.filters = {};

                    this.$store.dispatch(this.config.getVuexAlias('back.mensajeria.create.incidencia'), this.incidencia).then(res => {
                        this.$toast.success(res.data.message);
                        this.$router.push({ name: 'back.mensajes.index' });
                    }).finally(() => this.loading = false);
                }
            }

        },
        created() {
            this.loading = true;
            this.getPrioridades();
            this.getRoles();
            this.loading = false;
        },
        components: {
            PageTitleComponent, LoaderComponent, CkEditorComponent
        }
    }
</script>